import { Download, Refresh, CheckedFull } from '@gympass/yoga-icons';

import {
  DocDownloadReducer,
  DocDownloadState,
  docDownloadTypes,
} from './types';

export const docDownloadState = {
  type: docDownloadTypes.DEFAULT,
  icon: Download,
  button: 'DOC_DOWNLOAD.FORM.BUTTON.DOWNLOAD',
  helper: '',
  color: 'medium',
  agreed: false,
  url: '',
  filename: '',
};

export const docDownloadInit = (initial: DocDownloadState) => ({ ...initial });
export const docDownloadReducer: DocDownloadReducer = (state, action) => {
  switch (action.type) {
    case docDownloadTypes.AGREED: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case docDownloadTypes.LOADING: {
      return {
        ...state,
        type: docDownloadTypes.LOADING,
        icon: null,
        button: '',
        helper: 'DOC_DOWNLOAD.FORM.REQUEST.LOADING',
        color: 'medium',
      };
    }
    case docDownloadTypes.ERROR: {
      return {
        ...state,
        type: docDownloadTypes.ERROR,
        icon: Refresh,
        button: 'DOC_DOWNLOAD.FORM.BUTTON.TRY_AGAIN',
        helper: action.payload.message,
        color: 'error',
      };
    }
    case docDownloadTypes.SUCCESS: {
      return {
        ...state,
        ...action.payload,
        type: docDownloadTypes.SUCCESS,
        icon: CheckedFull,
        button: 'DOC_DOWNLOAD.FORM.BUTTON.FINISH',
        helper: 'DOC_DOWNLOAD.FORM.REQUEST.SUCCESS',
        color: 'hope',
      };
    }
    case docDownloadTypes.RESET: {
      return docDownloadInit(action.payload);
    }
    default: {
      throw new Error(`Action ${action.type} does not exist.`);
    }
  }
};
